import ApiService from "../../services/ApiService";
import { ContactPlacePopup } from "./ContactPlacePopup";

export class ContactPlaces {
  constructor(map, statusConfig, openTableCallback) {
    this.map = map;
    this.map.on("click", e => {
      that.clickHandler(e);
    });
    this.statusColor = {};
    statusConfig.forEach(sc => {
      this.statusColor[sc.value] = sc.color;
    });
    this.inited = false;
    this.active = false;
    this.mapState = {
      date: new Date(),
      status: [],
      byPrimaryAddress: false
    };
    this.addresses = undefined;
    this.placesSource = {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: []
      }
    };
    this.graphSource = {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: []
      }
    };
    this.popup = new ContactPlacePopup(openTableCallback, this.statusColor);
    this.popupStatus = "inited";
    let that = this;
    this.popup.on("close", () => {
      if (that.popupStatus === "opened") {
        that.popupStatus = "closed";
      }
    });
    this.popup.on("open", () => {
      that.popupStatus = "opened";
    });
    this.contactLayerNames = [
      "contactGraphLinks",
      "contactPlaces",
      "contactPlacesText",
      "contactGrapPerson"
    ];
  }

  async init() {
    return new Promise(resolve => {
      let that = this;
      let map = this.map;
      map.on("load", function() {
        if (!map.getSource("contactPlaces")) {
          map.addSource("contactPlaces", that.placesSource);
        }
        if (!map.getSource("graphSource")) {
          map.addSource("graphSource", that.graphSource);
        }
        if (!map.getLayer("contactGraphLinks")) {
          map.addLayer({
            id: "contactGraphLinks",
            type: "line",
            source: "graphSource",
            filter: ["==", "type", "link"],
            paint: {
              "line-color": ["get", "color"],
              "line-opacity": 1,
              "line-width": 3
            },
            layout: {
              visibility: "none"
            }
          });
        }
        if (!map.getLayer("contactPlaces")) {
          map.addLayer({
            id: "contactPlaces",
            type: "circle",
            source: "contactPlaces",
            paint: {
              "circle-color": "darkred",
              "circle-opacity": 0.7,
              "circle-radius": [
                "max",
                ["min", ["*", ["get", "weight"], 2], 30],
                10
              ]
            },
            layout: {
              visibility: "none"
            }
          });
        }
        if (!map.getLayer("contactPlacesText")) {
          map.addLayer({
            id: "contactPlacesText",
            type: "symbol",
            source: "contactPlaces",
            layout: {
              "text-field": "{weight}",
              "symbol-placement": "point",
              "text-max-angle": 25,
              visibility: "none",
              "text-padding": 5,
              "text-font": ["Noto Sans Regular All"],
              "text-size": 12
            },
            paint: {
              "text-color": "white"
            }
          });
        }
        if (!map.getLayer("contactGrapPerson")) {
          map.addLayer({
            id: "contactGrapPerson",
            type: "circle",
            source: "graphSource",
            filter: ["all", ["==", "type", "person"], ["==", "atPlace", false]],
            paint: {
              "circle-color": ["get", "color"],
              "circle-opacity": 0.7,
              "circle-radius": 10
            },
            layout: {
              visibility: "none"
            }
          });
        }
        that.inited = true;
        map.on("mouseenter", "contactPlaces", () => {
          map.getCanvas().style.cursor = "pointer";
        });
        map.on("mouseleave", "contactPlaces", () => {
          map.getCanvas().style.cursor = "";
        });
        map.on("mouseenter", "contactGrapPerson", e => {
          if (e.features && e.features.length > 0) {
            map.getCanvas().style.cursor = "default";
            let azons = [];
            e.features.forEach(f => azons.push(f.properties.azon));
            azons.sort();
            map.getCanvas().title = azons.join("\n");
          }
        });
        map.on("mouseleave", "contactGrapPerson", () => {
          map.getCanvas().style.cursor = "";
          map.getCanvas().title = "";
        });
        if (that.active) {
          that.show();
        }
        resolve();
      });
    });
  }

  async changeMapStatus({ date, status, byPrimaryAddress }) {
    this.mapState.date = date;
    this.mapState.status = status;
    this.mapState.byPrimaryAddress = byPrimaryAddress;
    if (this.addresses != undefined) {
      await this.updateGraph();
    }
    await this.updatePlaces();
  }

  async graphByAddress(addresses) {
    if (this.addresses !== addresses) {
      this.popupStatus = "inited";
    }
    this.addresses = addresses;
    if (addresses) {
      await this.updateGraph();
    } else {
      this.graphSource.data.features = [];
      this.map.getSource("graphSource").setData(this.graphSource.data);
      this.popupStatus = "inited";
    }
  }

  async updateGraph() {
    if (!this.inited || this.addresses === undefined) return;
    let data = (
      await ApiService.getContactsForPlace({
        date: this.mapState.date,
        statuses: this.mapState.status,
        addresses: this.addresses,
        byPrimaryAddress: this.mapState.byPrimaryAddress
      })
    ).data;
    if (data) {
      this.graphSource.data = data.fc;
      if (this.popupStatus !== "closed") {
        this.popup.open(this.map, data.place);
      }
    }
    this.graphSource.data.features.forEach(f => {
      if (f.properties.type === "link" || f.properties.type === "person") {
        if (this.statusColor[f.properties.status]) {
          f.properties.color = this.statusColor[f.properties.status];
        }
      }
    });
    this.map.getSource("graphSource").setData(this.graphSource.data);
  }

  async updatePlaces() {
    if (!this.inited) return;

    const result = await ApiService.getContactPlaces(this.mapState.date);

    if (result) {
      this.placesSource.data = result.data;
      this.map.getSource("contactPlaces").setData(this.placesSource.data);
    }
  }

  clickHandler(e) {
    var features = this.map.queryRenderedFeatures(e.point, {
      layers: ["contactPlaces"]
    });
    if (features.length > 0) {
      try {
        e.originalEvent.cancelBubble = true;
        let addresses = JSON.parse(features[0].properties.addresses);
        this.popupStatus = "inited";
        this.graphByAddress(addresses);
      } catch (e) {
        this.graphByAddress(undefined);
      }
    } else {
      this.graphByAddress(undefined);
    }
  }

  show() {
    this.active = true;
    if (this.inited) {
      for (let contactLayerName of this.contactLayerNames) {
        this.map.setLayoutProperty(contactLayerName, "visibility", "visible");
      }
    }
  }

  hide() {
    this.active = false;
    if (this.inited) {
      for (let contactLayerName of this.contactLayerNames) {
        this.map.setLayoutProperty(contactLayerName, "visibility", "none");
      }
      this.popup.remove();
      this.graphByAddress(undefined);
    }
  }
}
